<template>
  <div class="home">
	<div class="bg">
	</div>
  </div>
</template>

<script>
// @ is an alias to /src

</script>

<style lang="scss" scoped>
.home {
	height: 100%;
}
.bg {
	width: 100%;

	&__image {
		width: 100%;
	}
}

</style>
